<template lang="pug">
    v-container(fill-height fluid grid-list-md-4 )
        v-row
            v-col(xs='12' sm='6' md='3' v-for='item, index in elementos' :key='index')
                v-hover( v-slot:default="{ hover }" )
                    v-card( :elevation="hover ? 12 : 0" :color='hover ? "white": "grey lighten-5"' @click='item.callback()' )
                        v-card-text
                        v-col(align='center')
                            v-icon.mb-4(x-large :color='hover ? "primary" : "grey"') {{ item.icon }}
                            p.black--text {{item.name}}
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            recordContable:'Privileges/recordContable',
        }),
        elementos(){
            let result =  this.recordContable.map(item => ( { icon: item.icon, name: item.name, callback: () => this.$router.push({ name:item.routerName, params: { customerName: this.$route.params.customerName} }) }) )
            return result
        }
    }
}
</script>